import { jsx as _jsx } from "react/jsx-runtime";
import styles from "./Txt.module.scss";
export const Txt = ({ as: Component = "div", variant = "hl-6", overwrite = "", children, className = "", dataTestId = "", }) => {
    return (_jsx(Component, { className: `${styles.txt} ${styles["variant-" + variant] || ""} ${overwrite ? styles["overwrite-" + overwrite] : ""} ${className}`, "data-testid": dataTestId, children: children }));
};
//# sourceMappingURL=Txt.js.map